import React from "react";

export default class BlogPostResume extends React.Component 
{
    constructor(props)
    {
        super(props);

        this.post = this.props.post;     
    }

    getImage = (image) =>
    {
        if(image === null)
        {
            return(<></>)
        }

        const alt = image.alt !== '' ? image.alt : 'hometown';
        
        return(
            <div className="main-image">
                <img src={image.path} alt={alt}/>
            </div>
        )
    }
    
    render() 
    {    
        return (
            <div class="post single-item">
                
                <div className="resume">
                    <a href={this.post.url}>
                        {this.getImage(this.post.image)}
                    </a>

                    <h2><a href={this.post.url}>{this.post.title}</a></h2>

                    <ul className="tags">
                    {                
                        this.post.tags.map(tag =>
                        {                        
                            return (
                                tag.id !== 'success' ? (
                                <li class="big"><a href={'/blog/tags/'+tag.slug}>{tag.name}</a></li>
                                ) : (
                                <li class="big"><a href={'/pro/guide/tags/'+tag.slug}>{tag.name}</a></li>
                                )
                            )
                        })
                    }
                    </ul>
                    
                    <div 
                        dangerouslySetInnerHTML={{__html: this.post.teaser}}>
                    </div>

                    <a href={this.post.url} className="continue">Continue Reading →</a>
                </div>

            </div>  
        )
    }
};